import { formatOrderData } from '@beef/layout-kit/utils';
/* Функция для создания объекта с заказом для корзины.
 * Захардкожено добавление продукта (роутера и роутера+антенны), согласовано с корзинщиками.
 * Работает на основе стандартного formatOrderData с ручным добавлением товара */
export var formatCountrySeasonOrderData = function formatCountrySeasonOrderData(basketPayload) {
  // @ts-expect-error - кто-то ввел для formatOrderData обязательный параметр additionalCtnOptions: Object
  var requestData = formatOrderData(basketPayload);
  // Если есть productId (артикул товара из шопа), то добавляем со статическими параметрами указанными ниже
  if (basketPayload.productId) {
    // Элемент с товаром шопа. Формируем такую статическую структуру по согласованию с корзинщиками
    var productItem = {
      itemType: 'product',
      id: Number(basketPayload.productId),
      quantity: 1,
      isExcluded: false,
      parentItemId: null,
      details: {
        promotionId: null
      }
    };

    // Добавление товара имеет разные варианты в зависимости от наличия уже созданной корзины
    if (Array.isArray(requestData.body.items)) {
      requestData.body.items.push(productItem);
    } else {
      // В else находится логика добавления товара, если корзина уже существует. В этом кейсе requestData имеет иной формат
      // @ts-expect-error requestData.body на самом деле может быть массивом
      requestData.body.push(productItem);
    }
  }
  return requestData;
};